import { render, staticRenderFns } from "./userauthtable.vue?vue&type=template&id=6db2b418&scoped=true&"
import script from "./userauthtable.vue?vue&type=script&lang=js&"
export * from "./userauthtable.vue?vue&type=script&lang=js&"
import style0 from "./userauthtable.vue?vue&type=style&index=0&id=6db2b418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2b418",
  null
  
)

export default component.exports